import { Button, Col, Row } from 'reactstrap'
import { primary_color } from '../../../Helper/uiHelper'
import { useHistory } from 'react-router-dom'

const SuccessScreen = ({ onGoBack, createdTicketId, successHeading }) => {
  const history = useHistory()


  return (
    <div className='d-flex align-items-center justify-content-center'>
      {' '}
      <Row className='my-5 align-items-center' style={{ maxWidth: '700px' }}>
        <Col md={7}>
          <div style={{ flex: 1 }} className='mb-4'>
            <div className='font-weight-bold h2 mb-5' style={{ color: primary_color }}>
              {successHeading || "We're happy we could help you out! Thanks for choosing Locker rentals. Thankyou!"}
            </div>
            <Row>
              <Col md={createdTicketId ? 6 : 12}>
                <Button
                  style={{ background: primary_color, borderRadius: '15rem', width: '100%', border: 'none' }}
                  onClick={onGoBack}
                  className='subtitle1 py-3 mb-2 mr-2'>
                  Raise another ticket
                </Button>
              </Col>
              {createdTicketId && (
                <Col md={6}>
                  <Button
                    style={{ background: primary_color, borderRadius: '15rem', width: '100%', border: 'none' }}
                    onClick={() => {
                      history.push(`/redirect-to-dashboard?url=/query-tickets-list?selected_ids=${createdTicketId}&search_field=id`)
                    }}
                    className='subtitle1 py-3 mb-2'>
                    View ticket
                  </Button>
                </Col>
              )}
            </Row>
          </div>
        </Col>
        <Col md={1}></Col>
        <Col md={4}>
          <div style={{ flex: 1 }}>
            <img src='raise_ticket_success.png' style={{ width: '100%' }}></img>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default SuccessScreen
